// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__O8De_","label":"Category_label___mmqX","text":"Category_text__Cgnhc"};